<template>
    <div>
        <header class="my-3">
            <div v-if="$scopedSlots.title">
                <slot name="title"/>
            </div>
            <h4 v-else>{{ title }}</h4>

            <base-icon v-if="tooltip" v-b-tooltip.hover="tooltip" name="info" />

            <div class="ml-auto">
                <slot name="buttons" />
            </div>
        </header>
        <slot/>
    </div>
</template>

<script>
export default {
    props:
    {
        title : { type : String, default : () => "" },
		tooltip : { type : String, default : () => null },
    }
}
</script>

<style scoped>
header
{
    display: flex;
    align-items: center;
    gap: .25rem;
    min-height: 2.5rem;
}

header h6
{
    font-weight: 400 !important;
    margin: 0;
}
</style>
